import { cardAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    outline: '1px solid var(--compo-200)',
  },
});

const temaCard = defineMultiStyleConfig({ baseStyle });

export default temaCard;
